var currentVendorCategoriesId = [];
var category_id;
var speciality_id;
var categoryDeletableFlag = true;
var specialityDeletableFlag = true;

var currentCategoryClicked;
var currentSpecialityClicked;

import { getImageUrl } from "../helpers/mediaUrl";

export default class Vendor_category_speciality_details {
  constructor() {
    this.formstep1 = $("#formstep1");
    this.formstep2 = $("#formstep2");
    this.formstep3 = $("#formstep3");
    this.formstep4 = $("#formstep4");
    this.formstep5 = $("#formstep5");

    this.categorySubmitBtn = $("#categorySubmitBtn");
    this.categoryPrevBtn = $("#categoryPrevBtn");
    this.specialitySubmitBtn = $("#specialitySubmitBtn");
    this.specialityPrevBtn = $("#specialityPrevBtn");

    this.vendorSpecialitiesBox = $(".vendorSpecialitiesBox");
    this.categoryError = $("#categoryError");
    this.specialityError = $("#specialityError");
    this.GSTDetails_page = $(".GSTDetails-page");
    this.vendorCategoriesBox = $(".vendorCategoriesBox");
    this.basicDetails_page = $(".basicDetails-page");

    // Registering Events
    this.bindEvents();
  }

  bindEvents = () => {
    // $.ajax({
    //   type: "GET",
    //   url: baseURL + "api/Vendor/getCategories",
    //   headers: { Authorization: X_API_KEY },

    //   success: this.showCategoryOptions,
    // });
    this.categorySubmitBtn.on("click", this.vendorCategoriesFormSubmit);
    this.specialitySubmitBtn.on("click", this.vendorSpecialitiesFormSubmit);
    this.categoryPrevBtn.on("click", this.categoryPrevBtnAction);
    this.specialityPrevBtn.on("click", this.specialityPrevBtnAction);

    // $(window).on("load", this.getCategoryOptions);

    this.getCategoryOptions();
    // this.verifyOTPBtn.on("click", this.doVerifyOTP);
  };
  categoryCheckBoxclicked = async (e) => {
    currentCategoryClicked = e;

    category_id = e.target.attributes[3]["nodeValue"];

    if (!e.target.checked) {
      categoryDeletableFlag = false;

      $.ajax({
        type: "GET",
        url: baseURL + "api/Vendor/GetProductsByCategoryForServicing",
        headers: { Authorization: X_API_KEY },
        data: {
          category_id: category_id,
          // Offset: offsetCount,
        },
        success: this.doCategoryCheckOrUncheck,
      });
    }
  };

  doCategoryCheckOrUncheck = (res) => {
    categoryDeletableFlag = true;

    if (res == true) {
      window.$("#categoriesErrorModal").modal("show");

      currentCategoryClicked.target.checked = true;
    }
  };
  //To submit the categories of the vendor
  vendorCategoriesFormSubmit = async (e) => {
    e.preventDefault();
    if (categoryDeletableFlag == false) {
      alert("please try after some time");
      return;
    }

    //

    if ($(".categoryCheckBox:checked").length < 1) {
      this.categoryError.html("Please select atleast one product or service");
    } else {
      var category_ids_array = [];

      //to create array of category IDs
      for (let i = 0; i < $(".categoryCheckBox:checked").length; i++) {
        category_ids_array[i] = $(".categoryCheckBox:checked")[i].defaultValue;
      }

      //To save categories of the vendor in the db
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",

          url: baseURL + "api/Vendor/AddUpdateCategories",

          headers: { Authorization: X_API_KEY },

          data: {
            category_ids_array: category_ids_array,
          },

          success: () => {
            console.log("Successfully");
            resolve();
          },
          error: resolve,
        });
      });

      //To get Specialities of the selected categories
      $.ajax({
        type: "GET",
        url: baseURL + "api/Vendor/GetAllSpecialities",
        headers: { Authorization: X_API_KEY },
        success: this.doDisplaySpec,
      });

      this.categoryError.html("");
      this.vendorCategoriesBox.addClass("d-none");
      this.vendorSpecialitiesBox.removeClass("d-none");
    }

    //To get all specialities of selected categories
    // $.ajax({
    //   type: "GET",
    //   url: baseURL + "api/Vendor/GetAllSpecialities",
    //   headers: { Authorization: X_API_KEY },
    // });
  };

  //To submit the specialities of the vendor
  vendorSpecialitiesFormSubmit = async (e) => {
    e.preventDefault();

    //

    if ($(".specialityCheckBox:checked").length < 1) {
      this.specialityError.html("Please select atleast one speciality");
    } else {
      var speciality_ids_array = [];

      //to create array of speciality IDs
      for (let i = 0; i < $(".specialityCheckBox:checked").length; i++) {
        speciality_ids_array[i] = $(".specialityCheckBox:checked")[
          i
        ].defaultValue;
      }

      //To save specialities of the vendor in the db
      await new Promise((resolve) => {
        $.ajax({
          type: "POST",
          url: baseURL + "api/Vendor/AddUpdateSpecialities",

          headers: { Authorization: X_API_KEY },

          data: {
            speciality_ids_array: speciality_ids_array,
          },

          success: (resp) => {
            if (resp == true) {
              resp = "Specialities Updated Successfully";
            } else {
              resp = "Something went wrong";
            }
            $("#servicingCategorySpecialityFlowEndModalMsg").html(resp);

            window.$("#servicingCategorySpecialityFlowEndModal").modal("show");
            $("#servicingCategorySpecialityFlowEndModalCloseBtn").on(
              "click",
              this.claoseServicingCategorySpecialityFlowEndModal,
            );
            resolve();
          },
          error: resolve,
        });
      });

      var currentPath = window.location.pathname;

      var lastTenCharacters = currentPath.slice(-10);

      if (lastTenCharacters != "_dashboard") {
        this.GSTDetails_page.removeClass("d-none");
        this.vendorSpecialitiesBox.addClass("d-none");
        this.formstep2.removeClass("current-item");
        this.formstep3.addClass("current-item");
      }

      // this.reloadSpecialities();
      this.specialityError.html("");
    }
  };

  claoseServicingCategorySpecialityFlowEndModal = (e) => {
    // e.preventDefault();
    //
    // $("#servicingCategorySpecialityFlowEndModal").css('display', 'none')
    window.$("#servicingCategorySpecialityFlowEndModal").modal("hide");
  };

  // reloadSpecialities = () => {
  //   location.reload(true);
  //  };

  //To go back to Category Selection
  specialityPrevBtnAction = (e) => {
    e.preventDefault();
    this.vendorCategoriesBox.removeClass("d-none");
    this.vendorSpecialitiesBox.addClass("d-none");
  };

  //To go back to basic details
  categoryPrevBtnAction = (e) => {
    e.preventDefault();
    this.basicDetails_page.removeClass("d-none");
    this.vendorCategoriesBox.addClass("d-none");
    this.formstep2.removeClass("current-item");
    this.formstep1.addClass("current-item");
  };

  // To load the list of Specialities the vendor can choose
  getCategoryOptions = async () => {
    await this.getCurrentVendorCategories();
    $.ajax({
      type: "GET",
      url: baseURL + "api/Vendor/getCategories",
      headers: { Authorization: X_API_KEY },

      success: this.showCategoryOptions,
    });
  };

  showCategoryOptions = (res) => {
    this.getCurrentVendorCategories();

    var categoryCount = 20;
    var categoryCheckedFlag = ``;

    res.Product.forEach((element) => {
      categoryCheckedFlag = ``;

      for (var i = 0; i < currentVendorCategoriesId.length; i++) {
        if (currentVendorCategoriesId[i] == element.Picklist_ID) {
          categoryCheckedFlag = `checked`;
        }
      }

      //
      // var item = `<option value="${element.Picklist_display_value}">${element.Picklist_display_value}</option>`;
      var item = `<div class="col-4 col-md-2 d-flex justify-content-center my-2 ">
                      <div class="custom-control custom-checkbox image-checkbox">
                          <input type="checkbox" class="custom-control-input categoryCheckBox justify-content-center" id="categoryck${categoryCount}" value="${element.Picklist_ID}" ${categoryCheckedFlag}>
                          <label class="custom-control-label d-flex justify-content-center" for="categoryck${categoryCount}">
                              <img class="img-fluid categoryImage categoryImg${categoryCount}" style="width: 100px; height: 80px; object-fit: contain; background-color: #f5f5f5; padding: 5px; border-radius: 4px;" onerror="this.src='${baseURL}/assets/default.png'" alt="Image" loading="lazy">
                          </label>
                          <label class="d-flex justify-content-center">
                          <span class="fs-12 text-lowercase text-center text-capitalize">${element.Picklist_display_value}</span>
                          </label>
                      </div>
                  </div>`;
      $("#allProductCategoryDisplay").append(item);

      //Product category Image insert
      var prodCategoryImageURL = element.Icon_Url;
      var prodCategoryImageTagClassName = `categoryImg${categoryCount}`;
      $(`.${prodCategoryImageTagClassName}`).attr(
        "src",
        getImageUrl(prodCategoryImageURL),
      );

      categoryCount++;
    });
    res.Service.forEach((element) => {
      categoryCheckedFlag = ``;

      for (var i = 0; i < currentVendorCategoriesId.length; i++) {
        if (currentVendorCategoriesId[i] == element.Picklist_ID) {
          categoryCheckedFlag = `checked`;
        }
      }
      //
      // var item = `<option value="${element.Picklist_display_value}">${element.Picklist_display_value}</option>`;
      var item = `<div class="col-4 col-md-2 d-flex justify-content-center my-2 ">
                      <div class="custom-control custom-checkbox image-checkbox">
                          <input type="checkbox" class="custom-control-input categoryCheckBox justify-content-center" id="categoryck${categoryCount}" value="${element.Picklist_ID}" ${categoryCheckedFlag}>
                          <label class="custom-control-label d-flex justify-content-center" for="categoryck${categoryCount}">
                              <img class="img-fluid categoryImage categoryImg${categoryCount}" style="width: 100px; height: 80px; object-fit: contain; background-color: #f5f5f5; padding: 5px; border-radius: 4px;" onerror="this.src='${baseURL}/assets/default.png'" alt="Image" loading="lazy">
                          </label>
                          <label class="d-flex justify-content-center">
                          <span class="fs-12 text-lowercase text-center text-capitalize">${element.Picklist_display_value}</span>
                          </label>
                      </div>
                  </div>`;
      $("#allServiceCategoryDisplay").append(item);

      //Service category Image insert
      var serviceCategoryImageURL = element.Icon_Url;
      var serviceCategoryImageTagClassName = `categoryImg${categoryCount}`;
      $(`.${serviceCategoryImageTagClassName}`).attr(
        "src",
        getImageUrl(serviceCategoryImageURL),
      );

      categoryCount++;
    });
    $(".categoryCheckBox").on("click", this.categoryCheckBoxclicked);
  };

  //To Display Specialities of the selected categories (ARRAYS)
  doDisplaySpec = (res) => {
    // Convert old API response format to expected format
    if (!res.Categories && Array.isArray(res)) {
      const categoryName = res[0];
      const specialities = res[1];

      res = {
        Categories: [categoryName],
        [categoryName]: specialities,
      };
    }
    //To make the collapsable boxes function
    var collapsableBoxCounter = 221;
    //To gie unique ids to the speciality checkboxes
    var SpecialityCount = 1;

    //to avoid duplicates
    //try using on change function to empty
    $("#SpecialityBox").empty();

    //If none of the selected categories have specialities
    if (!res.Categories) {
      var item = `<h5 my-auto>Select a Category having specialities</h5>`;
      $("#SpecialityBox").append(item);
    } else {
      //To load each specialities Box

      res.Categories.forEach((element) => {
        //End current iteration if No Specialities for the current Category exists
        if (res[element] == null) {
          return;
        }

        //To load specialities of current Category
        var itemBody = ``;
        var checkedFlag = null;

        //to append specialities
        res[element].forEach((element) => {
          //to check the checkboxes
          if (element.Selected == true) {
            checkedFlag = "checked";
          } else {
            checkedFlag = null;
          }

          itemBody = `${itemBody}
                      <div class="col-4 col-md-2 d-flex justify-content-center my-2 ">
                        <div class="custom-control custom-checkbox image-checkbox">
                         <input type="checkbox" class="custom-control-input specialityCheckBox justify-content-center" id="specialityck${SpecialityCount}" value="${element.Picklist_ID}" ${checkedFlag}>
                          <label class="custom-control-label d-flex justify-content-center" for="specialityck${SpecialityCount}">
                              <img src="" id=${element.Picklist_ID} class="img-fluid specialityImage" style="width: 100px; height: 80px; object-fit: contain; background-color: #f5f5f5; padding: 5px; border-radius: 4px;" onerror="this.src='${baseURL}/assets/default.png'" alt="Image" loading="lazy">
                          </label>
                          <label class="d-flex justify-content-center">
                              <span class="fs-12 text-lowercase text-center text-capitalize">${element.Picklist_display_value}</span>
                          </label>
                        </div>
                      </div>`;

          SpecialityCount++;
        });

        var item1 = `<div id="accordion-${collapsableBoxCounter}" role="tablist" aria-multiselectable="true" class="o-accordion">
        <div class="card multi">
          <div class="card-header" role="tab" id="headingOne-${collapsableBoxCounter}">
              <h5 class="mb-0">
                  <div class="row row justify-content-between">
                      <div class="col-11">
                          &nbsp;
                          <p>${element}</p>
                      </div>
                      <div class="col-1 d-flex justify-content-end align-items-center">
                          <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne-${collapsableBoxCounter}" aria-expanded="true" aria-controls="collapseOne-${collapsableBoxCounter}">
                              <img src="assets/src/images/arrow-down-circle.svg" width="20" height="20" class="mx-auto d-block" alt="^">
                          </a>
                      </div>
                  </div>
              </h5>
          </div>

          <!-- Products COLLAPSABLE CARD -->
          <div id="collapseOne-${collapsableBoxCounter}" class="collapse show" role="tabpanel" aria-labelledby="headingOne-${collapsableBoxCounter}">
              <div class="card-block">
                  <div class="container">
                      &nbsp;


                      <!-- Columns start at 50% wide on mobile and bump up to 33.3% wide on desktop -->
                      <div class="row " id="SpecialitiesDisplay">${itemBody}</div></div></div></div></div></div>`;

        $("#SpecialityBox").append(item1);
        collapsableBoxCounter++;
      });
      //Call to Function to load the S3 Category images in the respective image tags
      this.loadSpecialityImages(res);
    }
    $(".specialityCheckBox").on("click", this.specialityCheckBoxclicked);
  };

  //To load the S3 Category images in the respective image tags
  loadSpecialityImages = (res) => {
    //For each Category ABC
    res.Categories.forEach(async (element) => {
      //End current iteration if No Specialities for the current Category exists
      if (res[element] == null) {
        return;
      }
      //For each Speciality in Category ABC
      res[element].forEach(async (elementS) => {
        const specialityImage = getImageUrl(elementS.Icon_Url);
        const el = document.getElementById(elementS.Picklist_ID);
        if (el) {
          el.src = specialityImage;
        }
      });
    });
  };

  specialityCheckBoxclicked = async (e) => {
    currentSpecialityClicked = e;

    speciality_id = e.target.attributes[3]["nodeValue"];

    if (!e.target.checked) {
      $.ajax({
        type: "GET",
        url: baseURL + "api/Vendor/GetProductsBySpecialityForServicing",
        headers: { Authorization: X_API_KEY },

        data: {
          speciality_id: speciality_id,
          // Offset: offsetCount,
        },
        success: this.doSpecialityCheckOrUncheck,
      });
    }
  };

  doSpecialityCheckOrUncheck = (res) => {
    //Array of Products are returned if they exist for the speciality, Else it returns false.
    if (res != false) {
      $(".modal-body-product-list").empty();

      window.$("#SpecialityErrorModal").modal("show");

      var count = 1;
      var productList = `Products/Services:<br>`;
      res.forEach((element) => {
        productList = `${productList}
                      <span>${count} - ${element.Product_Service_Name}</span>
                      <br>`;
        count++;
      });

      $(".modal-body-product-list").append(productList);

      currentSpecialityClicked.target.checked = true;
    }
  };

  getCurrentVendorCategories = async () => {
    return new Promise((resolve) => {
      $.ajax({
        type: "GET",
        url: baseURL + "api/vendor/GetVendorCategories",
        headers: { Authorization: X_API_KEY },
        success: (res) => {
          this.GetCurrentCategoriesId(res);
          resolve();
        },
        error: () => resolve(),
      });
    });
  };

  GetCurrentCategoriesId = (res) => {
    res.forEach((element) => {
      currentVendorCategoriesId.push(element.Picklist_ID);

      //
      // var item = `<option value="${element.Picklist_display_value}">${element.Picklist_display_value}</option>`;
      //     var item = `<div class="col-4 col-md-2 d-flex justify-content-center my-2 ">
      //     <div class="custom-control custom-checkbox image-checkbox">
      //         <input type="checkbox" class="custom-control-input categoryCheckBox justify-content-center" id="categoryck${categoryCount}" value="${element.Picklist_ID}">
      //         <label class="custom-control-label d-flex justify-content-center" for="categoryck${categoryCount}">
      //             <img src="assets/src/images/pancake.jpeg" alt="#" class="img-fluid rounded-circle categoryImage">
      //         </label>
      //         <label class="d-flex justify-content-center">
      //         <span class="fs-12 text-lowercase text-center">${element.Picklist_display_value}</span>
      //         </label>
      //     </div>
      // </div>`;
      //     $("#allProductCategoryDisplay").append(item);
      //     categoryCount++;
    });
  };
}

